import React from 'react';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';

import AppBar from '../util/ui/AppBar';
import { MenuViewerPage } from '../Menu/ViewerPage';
import { Page as DiscountViewerPage } from '../Discount/ViewerPage';
import { makeStyles } from '@material-ui/core';

import * as ROUTES from '../constants/routes';

export function App() {
  const classes = useStyles();

  return (
    <Router>
      <div className={classes.root}>
        <AppBar buttons={[]}>
        </AppBar>

        <main className={classes.mainContent}>
          <Route exact path={ROUTES.LANDING} component={MenuViewerPage} />
          <Route exact path={ROUTES.DISCOUNTS_VIEWER} component={DiscountViewerPage} />

        </main>
      </div>
    </Router>
  );
}


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  mainContent: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    minHeight: '100%',
  },
}));